import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ModalState {
	modalName?: string
	type?: 'error' | 'success'
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	modalInfo: any
	disabledOnClose?: boolean
}

const initialState: ModalState = {
	modalName: '',
	type: undefined,
	modalInfo: undefined,
	disabledOnClose: undefined,
}

export const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		openModal: (
			state,
			{
				payload: { name, type, modalInfo, disabledOnClose },
			}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
			PayloadAction<{
				name: string
				type?: 'error' | 'success'
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				modalInfo?: any
				disabledOnClose?: boolean
			}>
		) => {
			if (state.modalName) return

			state.modalName = name
			state.type = type
			state.modalInfo = modalInfo
			state.disabledOnClose = disabledOnClose
		},
		closeModal: state => {
			state.modalName = initialState.modalName
		},
		reset: () => initialState,
	},
})

export const modalCreators = modalSlice.actions

export const modalReducer = modalSlice.reducer
